import { useMemo } from 'react';
import { ValidationRules } from 'react-hook-form';
import { isPossiblePhoneNumber } from 'react-phone-number-input';

export const useRequiredValidation = () =>
  useMemo(
    () => ({
      required: 'This field is required',
    }),
    [],
  );

export const useRequiredAndMinMaxValidation = (min: number, max: number) =>
  useMemo<ValidationRules>(
    () => ({
      required: `This field is required`,
      min: { value: min, message: `Value should be greater then ${min}` },
      max: { value: max, message: `Value should be lower then ${max}` },
    }),
    [max, min],
  );

export const usePasswordValidation = (password: string, repeatPassword: string, minLength: number) =>
  useMemo<ValidationRules>(
    () => ({
      required: `This field is required`,
      minLength: { value: minLength, message: `This field should be longer then ${minLength} characters` },
      validate: (data) => {
        if (password !== repeatPassword) {
          return 'Passwords do not match';
        }
      },
    }),
    [minLength, password, repeatPassword],
  );
export const usePhoneNumberValidation = () =>
  useMemo<ValidationRules>(
    () => ({
      validate: (value?: string) => !value || isPossiblePhoneNumber(value) || 'Invalid phone number',
    }),
    [],
  );
